import FileDetails from '../../../components/FileDetails';

export default FileDetails;
